import Point from "@arcgis/core/geometry/Point.js";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";
import proj4 from "proj4";

import { PROJECTIONS } from "@/components/places/constants";

export function isValidCoordinate(x, y) {
  const lonMin = -180,
    lonMax = 180; // Longitude range for EPSG:4326
  const latMin = -90,
    latMax = 90; // Latitude range for EPSG:4326

  // Helper function to check if a point is valid in EPSG:4326
  return (
    Math.floor(x) >= lonMin &&
    Math.floor(x) <= lonMax &&
    Math.floor(y) >= latMin &&
    Math.floor(y) <= latMax
  );
}

export function transformCoordinates(
  coords,
  isCrs,
  fromProj,
  toProj = PROJECTIONS["4326"]
) {
  if (typeof coords[0] === "number") {
    // Single coordinate [x, y]
    const centerPoint = new Point({
      latitude: coords[1],
      longitude: coords[0]
    });
    const geometryVal: any =
      webMercatorUtils.webMercatorToGeographic(centerPoint);
    return !isCrs && isValidCoordinate(coords[0], coords[1])
      ? [geometryVal?.longitude, geometryVal?.latitude]
      : proj4(fromProj, toProj, [coords[0], coords[1]]);
  } else if (Array.isArray(coords[0])) {
    // MultiPoint, LineString, Polygon, etc.
    return coords.map((coord) =>
      transformCoordinates(coord, isCrs, fromProj, toProj)
    );
  }
  return coords;
}

// Function to handle different GeoJSON types
export function transformGeoJSON(
  geojson,
  isCrs,
  fromProj,
  toProj = PROJECTIONS["4326"]
) {
  if (geojson?.type === "FeatureCollection") {
    geojson.features = geojson?.features.map((feature) =>
      transformGeoJSON(feature, isCrs, fromProj, toProj)
    );
  } else if (geojson?.type === "Feature") {
    geojson.geometry = transformGeoJSON(
      geojson?.geometry,
      isCrs,
      fromProj,
      toProj
    );
  } else if (geojson?.type === "GeometryCollection") {
    geojson.geometries = geojson?.geometries.map((geometry) =>
      transformGeoJSON(geometry, fromProj, toProj)
    );
  } else if (geojson?.type === "Point" || geojson?.type === "MultiPoint") {
    geojson.coordinates = transformCoordinates(
      geojson?.coordinates,
      isCrs,
      fromProj,
      toProj
    );
  } else if (
    geojson?.type === "LineString" ||
    geojson?.type === "MultiLineString"
  ) {
    geojson.coordinates = transformCoordinates(
      geojson?.coordinates,
      isCrs,
      fromProj,
      toProj
    );
  } else if (geojson?.type === "Polygon" || geojson?.type === "MultiPolygon") {
    geojson.coordinates = transformCoordinates(
      geojson?.coordinates,
      isCrs,
      fromProj,
      toProj
    );
  }
  return geojson;
}
